import { CALL_ANSWERED, CALL_COMPLETED, CALL_ENDED, CALL_TRANSFERRED, INCOMING_CALL, INITIALIZED, LOGGED_IN, LOGGED_OUT, NAVIGATE_TO_RECORD, OUTGOING_CALL_STARTED, PUBLISH_TO_CHANNEL, USER_AVAILABLE, USER_UNAVAILABLE } from './ThirdPartyToHostEvents';
export const POPUP_OPENED = 'POPUP_OPENED';
export const POPUP_CLOSED = 'POPUP_CLOSED';
export const REMOTE_OPENED = 'REMOTE_OPENED';
export const HEARTBEAT_REQUEST = 'HEARTBEAT_REQUEST';
export const HEARTBEAT_RESPONSE = 'HEARTBEAT_RESPONSE';
export const DUPLICATE_POPUP_OPENED = 'DUPLICATE_POPUP_OPENED';
export const OPEN_WIDGET = 'OPEN_WIDGET';
export const REMOTE_OPENED_ACK = 'REMOTE_OPENED_ACK';
export const UPDATE_CALL_PROVIDER = 'UPDATE_CALL_PROVIDER';
export const REFRESH_REQUEST = 'REFRESH_REQUEST';
export const INITIATE_OUTBOUND_CALL = 'INITIATE_OUTBOUND_CALL';
export const OPEN_PROVIDER_MENU = 'OPEN_PROVIDER_MENU';
const fromPopupEventsMap = {
  POPUP_OPENED,
  HEARTBEAT_RESPONSE,
  REFRESH_REQUEST
};
const fromRemoteEventsMap = {
  REMOTE_OPENED,
  HEARTBEAT_REQUEST,
  DUPLICATE_POPUP_OPENED,
  OPEN_WIDGET,
  POPUP_CLOSED,
  REMOTE_OPENED_ACK,
  UPDATE_CALL_PROVIDER,
  REFRESH_REQUEST
};
const fromSelfEventsMap = {
  UPDATE_CALL_PROVIDER
};
const fromHostAppEventsMap = {
  INITIATE_OUTBOUND_CALL,
  OPEN_PROVIDER_MENU
};
const broadcastSdkEventsMap = {
  CALL_ANSWERED,
  CALL_COMPLETED,
  CALL_ENDED,
  CALL_TRANSFERRED,
  INCOMING_CALL,
  INITIALIZED,
  LOGGED_IN,
  LOGGED_OUT,
  NAVIGATE_TO_RECORD,
  OUTGOING_CALL_STARTED,
  PUBLISH_TO_CHANNEL,
  USER_AVAILABLE,
  USER_UNAVAILABLE
};
const broadcastEventsMap = Object.assign({}, broadcastSdkEventsMap, fromPopupEventsMap, fromRemoteEventsMap, fromSelfEventsMap, fromHostAppEventsMap);
export const isBroadcastSdkEvent = type => {
  return type in broadcastSdkEventsMap;
};
export const isBroadcastEvent = type => {
  return type in broadcastEventsMap;
};
export const isFromPopupEvent = type => {
  return type in fromPopupEventsMap;
};
export const isFromRemoteEvent = type => {
  return type in fromRemoteEventsMap;
};
export const isFromSelfEvent = type => {
  return type in fromSelfEventsMap;
};
export const isFromParentEvent = type => {
  return type in fromHostAppEventsMap;
};